module.exports = __webpack_public_path__ + "static/media/imc.00ed455a.gif";